import { Button, ButtonTheme } from '@apply/components';
import { MouseEventHandler } from 'react';

interface ResignDrawButtonProps {
    handleClick: MouseEventHandler<Element> | undefined;
}
export const ResignDrawButton = ({ handleClick }: ResignDrawButtonProps) => {
    return (
        <Button
            id='secondaryButton'
            theme={ButtonTheme.Secondary}
            width='160px'
            handleClick={handleClick}
        >
            Re-Sign Draw
        </Button>
    );
};
